export const syncMenu = {
	title: "Delivery Menu ({{externalStoreType}})",
	description:
		"Select the product from Zig's list to be associated with the item from {{externalStoreType}}. The items will become unique.",
	menuNameByExternalType: "Delivery Menu ({{externalStoreType}})",
	entriesLabel: "Entries",
	emptyTab: "No products in this tab.",
	emptyState: {
		title: "No products with pending issues",
		description: "Synced products did not present any pending issues to be corrected",
	},
	tabs: {
		synced: "Synced",
		pending: "Pending",
		notSynced: "Not synced",
	},
	syncStatusTag: {
		synced: "Synced",
		pending: "Pending",
		notSynced: "Not synced",
	},
	stepLabel: "Step {{number}}",
	requiredSuffix: "(required)",
	correctionSuggested: "{{count}} suggested correction(s)",
	corrected: "CORRECTED",
	improvementSuggested: "{{count}} suggested improvement(s)",
	improvementModal: {
		title: "Suggested improvement",
		types: {
			name: "Update name",
			price: "Update price",
			sku: "Update SKU",
		},
		changeFromTo: 'From "{{current}}" to "{{suggested}}"',
		emptyValue: "(empty)",
		cancel: "Cancel",
		updateAll: "Update all",
	},
	improvementSuccess: {
		title: "Success!",
		description: "The suggestions were corrected successfully!",
	},
	filterByStore: "Filter by store",
	transferProducts: {
		warning:
			"{{amount}} products were not synced. Would you like to import them into the Delivery menu?",
		description: "Select the items you would like to import, or finish to proceed.",
		amountItemsSelected: "<strong>{{amount}}</strong> items selected",
		completeBtn: "Finish without importing",
		importItemsBtn: "Import items",
	},
	notSynced: {
		pendingItems: "{{count}} pending items",
		pendingDescription:
			"No similar SKU was found between the products and complements to be synced. Import the listed items to manage them in Zig.",
		itemsSelected: "{{selected}}/{{total}} items selected",
		importInfo:
			"Products will be imported {{perPage}} at a time to ensure the system runs smoothly",
		importButton: "Import selected items",
		requiredSuffix: "(Required)",
		empty: {
			title: "No products to sync",
			description: "All products have already been imported and synced to Zig.",
		},
	},
	bindProduct: {
		searchPlaceholder: "Search for another product to sync",
		allProducts: "All products",
		notProductFound: "No product found",
		errorProductFound: "An error occurred while searching for products",
		similarity: {
			title: "No similar products found",
			description:
				"Search in the search bar above, or skip to the next product.<br/>You will be able to import the products without similarity at the end of the synchronization.",
		},
		saveLater: "Save and continue later",
		undo: "Undo previous action",
		completeSync: "Complete synchronization",
		skipAll: "Go to last",
		skuInfo: {
			title: "The SKU of this product will be replaced",
			description:
				"The SKU from ZIG (selected product on the side) will overwrite both menus. This will allow centralized management.",
		},
		undoModal: {
			title: "Undo synchronization",
			description:
				"Select which products you want to undo synchronization. You can sync them again at any time.",
			okText: "Undo synchronization",
			cancelText: "Cancel",
		},
		reImport: "Re-import product",
		reImportLoading: "Re-importing product...",
		reImportBlockedDuplicatedSku:
			"Cannot re-import: this product has complements with duplicated SKU.",
		duplicatedSkuAlert: {
			title: "Re-import unavailable",
			description:
				"This product has complements (or main item) with duplicated SKUs. Fix the SKUs in iFood before re-importing.",
		},
	},
	productCard: {
		descriptionLabel: "Description",
		optionsLabel: "Add-ons",
		syncedSectionsLabel: "Synced sections",
		syncAriaLabel: "Synchronize",
		active: "Active",
		inactive: "Inactive",
	},
	transferProductSuccess: {
		title: "Integration complete",
		description:
			"Your integration is complete, and your products have been successfully synced!",
		button: "View products and menus",
	},
	syncMenuSuccess: {
		title: "Integration complete",
		description:
			"Your integration is complete, and your products have been successfully synced!",
		button: "View products and menus",
		continue: "View unimported products",
	},
	errorContent: {
		title: "Unable to import products",
		description:
			"Something unexpected happened, and we couldn't complete the product import. Complete your integration and finish your menu later.",
		completeBtn: "Complete sync without importing",
		retryBtn: "Try to import again",
	},
	onboarding: {
		step1: {
			title: "We will display one product at a time",
			description:
				"Each imported product will be displayed alongside equivalent suggestions in the ZIG product catalog. You'll select the ideal product to unify.",
		},
		step2: {
			title: "A single SKU",
			description:
				"When selecting the product, the SKU from ZIG will prevail and you'll be able to manage it centrally in our dashboard.",
		},
		step3: {
			title: "Import what's not yet on Zig",
			description:
				"When you've finished synchronizing the equivalent items, you'll be able to import the products that weren't identified in the ZIG catalog. This way, you'll have all your products in one place!",
		},
		skipBtn: "Skip",
		submitBtn: "Start synchronization",
	},
	completeSyncModal: {
		title: "Complete synchronization",
		text:
			"Eba! You have synchronized all the products!<br/>Do you want to undo the last synchronization or can we finish this step?",
		undoBtn: "Undo the last synchronization",
		completeBtn: "Finish step",
	},
};
